<div class="subBlockContent">
  <div id="view-high-growth-offers" class="child-body" style="border-right: 1px solid #dee2e6;">
    <child-header [title]="'View High Growth Offers'" (closeEvent)="close()"></child-header>
    <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false">
    </loading-screen>
    <div class="inner-subBlock-wrapper">
      <label class="tenant-info-title">HIGH GROWTH OFFERS</label>
        <div class="row">
          <div class="col-md-10 page-title-description" style="margin: 20px 0px 25px 25px;">
              <p>
                High Growth Offers assist customers in the commercial and government market segments to significantly increase their existing Acrobat Pro seats.
              </p>
              <br>
              <p>
                High Growth Offers are based on a Minimum Order Quantity (MOQ) of 100, 250 or 500 seats. Customers must agree to a 3YC with a minimum commitment (MC) quantity greater than or equal to the required MOQ. The MOQ and pricing will remain applicable for the duration of the 3YC term.
              </p>
          </div>
        </div>
      <div class="top-divider"></div>

      <!-- <label class="tenant-info-title" >CRITERIA</label>

      <div class="row">
        <div class="col-md-2 page-title-description" style="margin: 25px 0px 25px 25px;">
          <span>3 YEAR COMMIT</span>
        </div>
        <div colspan="4" *ngIf="loadingCriteria" class="azure-loading">
          <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
        </div>
        <div class="middle" *ngIf="!loadingCriteria">
          <img *ngIf="threeYC" src="../../images/site-icons/yes.svg" class="yes-no-icon-size">
          <img *ngIf="!threeYC" src="../../images/site-icons/no.svg" class="yes-no-icon-size">
        </div>
        <div class="middle" *ngIf="!loadingCriteria">
          <button
            class="button button-red button-round button-large"
            [disabled]="threeYC"
            (click)="goToEditCustomer()"
          >
            Sign Up 3YC
          </button>
        </div>
      </div>

      <div class="top-divider"></div> -->

      <label class="tenant-info-title">OFFERS</label>
      <div class="example-element-detail" style="margin: 20px 0px 25px 25px; width: 96%;">
        <div colspan="4" *ngIf="loadingOffers" class="azure-loading">
          <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
        </div>
        <mat-radio-group
          *ngIf="!loadingOffers"
          style="width: 100%;"
          aria-labelledby="example-radio-group-label"
          class="example-radio-group"
          [(ngModel)]="OfferChosen"
        >
        <table mat-table [dataSource]="eligibleOffers" class="mat-elevation-z8 demo-table">
          <!-- Button Column -->
          <!-- <ng-container matColumnDef="selectBtn">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;"></th>
            <td mat-cell *matCellDef="let element">
              <mat-radio-button class="example-radio-button" [value]="element">
              </mat-radio-button>
            </td>
          </ng-container> -->
        
          <!-- Odder ID Column -->
          <ng-container matColumnDef="offerId">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: left;">OFFER ID</th>
            <td mat-cell *matCellDef="let element" class="align-left">{{element?.offerId}}</td>
          </ng-container>
        
          <!-- Desc Column -->
          <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef style="width: 20%; text-align: left;">DESCRIPTION</th>
            <td mat-cell *matCellDef="let element" class="align-left">{{element?.stock_description}}</td>
          </ng-container>
        
          <!-- minimumQty Column -->
          <ng-container matColumnDef="minimumQty">
            <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: left;">MINIMUM QTY</th>
            <td mat-cell *matCellDef="let element" class="align-left">{{element?.eligibilityCriteria?.minQuantity}}</td>
          </ng-container>

          <!-- unitPrice Column -->
          <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: right;">UNIT PRICE</th>
            <td mat-cell *matCellDef="let element" class="align-right">{{element?.reseller_buy | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
          </ng-container>

          <!-- totalPrice Column -->
          <ng-container matColumnDef="totalPrice">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;">TOTAL PRICE</th>
            <td mat-cell *matCellDef="let element" class="align-right">{{ element?.eligibilityCriteria?.minQuantity * commonService.toNumber(element.reseller_buy) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
          </ng-container>

          <!-- request button Column -->
          <ng-container matColumnDef="requestBtn">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;"></th>
            <td mat-cell *matCellDef="let element" class="align-right">
              <button
                *ngIf="!threeYC || !minQtyOK(element?.eligibilityCriteria?.minQuantity)"
                class="button button-red button-medium button-center-left"
                (click)="requestThreeYC(element)"
              >
                {{'Request 3YC - ' + element?.eligibilityCriteria?.minQuantity + ' MC' }}
              </button>
            </td>
          </ng-container>

          <!-- add button Column -->
          <ng-container matColumnDef="addBtn">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: right;"></th>
            <td mat-cell *matCellDef="let element" class="align-right">
              <button
                class="button button-red button-medium button-center-left"
                [disabled]="!threeYC || !minQtyOK(element?.eligibilityCriteria?.minQuantity)"
                (click)="buyNow(element)"
              >
                Buy Now
              </button>
            </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
          <!-- <mat-radio-button *ngFor="let offer of eligibleOffers" class="example-radio-button" [value]="offer">
            <span style="font-weight: bold;">Offer Id:</span>{{ offer?.offerId }}
            <span style="font-weight: bold;">Offer Description:</span>{{ offer?.stock_description }}
            <span style="font-weight: bold;">Minimum Quantity:</span>{{ offer?.eligibilityCriteria?.minQuantity }}
          </mat-radio-button> -->
        </mat-radio-group>
      </div>
      <div class="top-divider"></div>

      <!-- <div class="row"> -->
        <!-- <div class="col button-center" style="margin-bottom: 20px;">
          <button 
            class="button button-red button-large button-center-left"
            [disabled]="!OfferChosen"
          >
            Schedule On Renewal
          </button>
        </div> -->
        <!-- <div class="col button-center" style="margin-bottom: 20px;">
          <button
            class="button button-red button-large button-center-left"
            [disabled]="!OfferChosen || !threeYC"
            (click)="buyNow()"
          >
            Buy Now
          </button>
        </div>
      </div> -->
    </div>

  </div>



  <router-outlet></router-outlet>

</div>
